module.exports = __webpack_public_path__ + "img/BUTAGAZ.3013d70f.png";